import {
  getAqiColor,
  getAqiDescription,
  getUvDescription,
  getUvIndexColor,
} from '../../utils/skinResultsUtils';

function EnvItem({ icon, label, value, valueStyle }) {
  if (value == null || value === '') return null;
  return (
    <span className="skin-routine-env-item">
      <span className="skin-routine-env-icon" aria-hidden="true">{icon}</span>
      <span className="skin-routine-env-label skin-text-small">{label}</span>
      <span className="skin-routine-env-value" style={valueStyle}>{value}</span>
    </span>
  );
}

const EnvironmentTile = ({ environment }) => {
  if (!environment) {
    return (
      <div className="skin-routine-env-tile">
        <p className="routine-tile-title">Environmental Context</p>
        <p className="skin-routine-score-unavailable">Environment data unavailable</p>
      </div>
    );
  }

  const hasAny = Boolean(
    environment.location
    || environment.temperature != null
    || environment.humidity != null
    || environment.uv_index != null
    || environment.wind_speed != null
    || environment.aqi != null
    || environment.pressure != null
    || environment.visibility != null
    || environment.weather_condition
    || environment.uv_level,
  );

  return (
    <div className="skin-routine-env-tile">
      <p className="routine-tile-title">Environmental Context</p>
      {hasAny ? (
        <div className="skin-routine-env-grid">
          <EnvItem
            label="Location"
            value={environment.location}
            icon={(
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><path d="M12 21s7-5.2 7-11a7 7 0 1 0-14 0c0 5.8 7 11 7 11z" /><circle cx="12" cy="10" r="2.5" /></svg>
            )}
          />
          <EnvItem
            label="Temp"
            value={environment.temperature != null ? `${Math.round(environment.temperature)} C` : null}
            icon={(
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><path d="M14 14.76V5a2 2 0 1 0-4 0v9.76a4 4 0 1 0 4 0z" /></svg>
            )}
          />
          <EnvItem
            label="UV Level"
            value={environment.uv_level || (environment.uv_index != null ? getUvDescription(environment.uv_index) : null)}
            valueStyle={{ color: getUvIndexColor(environment.uv_index ?? 0) }}
            icon={(
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3" /><path d="M12 2v3M12 19v3M4.93 4.93l2.12 2.12M16.95 16.95l2.12 2.12M2 12h3M19 12h3M4.93 19.07l2.12-2.12M16.95 7.05l2.12-2.12" /></svg>
            )}
          />
          <EnvItem
            label="Humidity"
            value={environment.humidity != null ? `${Math.round(environment.humidity)}%` : null}
            icon={(
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3s5 5.2 5 9a5 5 0 0 1-10 0c0-3.8 5-9 5-9z" /></svg>
            )}
          />
          <EnvItem
            label="Wind"
            value={environment.wind_speed != null ? `${environment.wind_speed} km/h` : null}
            icon={(
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><path d="M3 12h12a2 2 0 1 0-2-2" /><path d="M3 18h14a2.5 2.5 0 1 1-2.5 2.5" /><path d="M3 6h9a2 2 0 1 1-2-2" /></svg>
            )}
          />
          <EnvItem
            label="AQI"
            value={environment.aqi != null ? `${environment.aqi} (${getAqiDescription(environment.aqi)})` : null}
            valueStyle={{ color: getAqiColor(environment.aqi) }}
            icon={(
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><path d="M4 14h16M6 10h12M8 6h8" /></svg>
            )}
          />
          <EnvItem
            label="Pressure"
            value={environment.pressure != null ? `${environment.pressure} hPa` : null}
            icon={(
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
            )}
          />
          <EnvItem
            label="Visibility"
            value={environment.visibility != null ? `${environment.visibility} km` : null}
            icon={(
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7-10-7-10-7z" /><circle cx="12" cy="12" r="2.5" /></svg>
            )}
          />
          <EnvItem
            label="Weather"
            value={environment.weather_condition || environment.condition}
            icon={(
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><path d="M18 10a4 4 0 0 0-8 0v1H7a3 3 0 1 0 0 6h11a3 3 0 1 0 .2-6H18z" /></svg>
            )}
          />
        </div>
      ) : (
        <p className="skin-routine-score-unavailable">Environment data unavailable</p>
      )}
    </div>
  );
};

export default EnvironmentTile;
